import styled from 'styled-components';
import { FlexColumn } from '../../styled/common';

export const PopularRequestsSection = styled(FlexColumn)`
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 20px;
  gap: 10px;
  padding: 0 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 15px 40px 0 30px;
    gap: 15px;
  }
  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 0 20px 0 10px;
  }
`;

export const PopularRequestsList = styled.ul`
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 15px;
  }
`;

export const Title = styled.h5`
  margin: 0;
  padding: 20px 0;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme: { colors } }) => colors.text.primary};

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 20px 10px;
  }
`;

export const Chip = styled.li`
  background: ${({ theme: { colors } }) => colors.background.tertiary};
  border-radius: 100px;
  padding: 0;
  transition: background-color 0.2s ease;
  border: none;

  a {
    color: ${({ theme: { colors } }) => colors.text.primary};
    font-size: 15px;
    padding: 10px 20px;
    display: inline-block;
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme: { colors } }) => colors.systemColors.blue};
    }
  }
`;
